import React from "react";
import { Mail, Phone, ClipboardList, Target, MessageSquare } from "lucide-react";
import { Avatar, ArrowLink } from "@/portal/ui/Layout";
import { Button } from "@/portal/ui/Button";
import { Modal } from "@/portal/ui/Modal";

const pmSrc = (pm) => (pm?.avatar_url ? `${process.env.REACT_APP_BACKEND_URL}${pm.avatar_url}` : undefined);

const ROLE_POINTS = [
  [ClipboardList, "Responsabil pentru coordonarea proiectului"],
  [Target, "Punct de contact principal"],
  [MessageSquare, "Colaborare directă și suport în decizii"],
];

/** Cardul „Manager de proiect” din antetul proiectului. */
export function PmCard({ pm, onContact }) {
  if (!pm?.name) return null;
  return (
    <aside className="cp-panel p-5" data-testid="pm-card" aria-label="Manager de proiect">
      <div className="cp-h3 mb-3">Manager de proiect</div>
      <div className="flex items-center gap-3">
        <Avatar name={pm.name} src={pmSrc(pm)} size="lg" />
        <div className="min-w-0"><div className="text-[15px] font-semibold text-cp-text truncate">{pm.name}</div><div className="text-[12.5px] text-cp-text-2 truncate">{pm.job_title || "Project Manager"}</div></div>
      </div>
      <ul className="mt-4 pt-4 border-t border-cp-border space-y-2.5">
        {ROLE_POINTS.map(([Icon, txt]) => <li key={txt} className="flex items-center gap-2.5 text-[13px] text-cp-text-2"><Icon className="h-4 w-4 text-cp-text-3 shrink-0" aria-hidden="true" />{txt}</li>)}
      </ul>
      <div className="mt-4 pt-4 border-t border-cp-border"><ArrowLink onClick={onContact} testid="pm-card-contact">Contactează managerul</ArrowLink></div>
    </aside>
  );
}

export function ContactPmModal({ pm, project, open, onOpenChange }) {
  if (!pm) return null;
  const subject = encodeURIComponent(`[${project?.code || ""}] ${project?.name || ""} — întrebare client`);
  return (
    <Modal open={open} onOpenChange={onOpenChange} title="Contactează managerul" testid="contact-pm-modal" size="sm"
      description="Managerul dedicat îți răspunde pentru clarificări, actualizări sau orice altă întrebare legată de proiect.">
      <div className="flex items-center gap-3 mb-5">
        <Avatar name={pm.name} src={pmSrc(pm)} size="xl" />
        <div><div className="text-[16px] font-semibold text-cp-text">{pm.name}</div><div className="text-[13px] text-cp-text-2">{pm.job_title || "Project Manager"}</div></div>
      </div>
      <div className="space-y-2 pb-3">
        {pm.email && <Button as="a" href={`mailto:${pm.email}?subject=${subject}`} className="w-full justify-start" data-testid="contact-email"><Mail /> {pm.email}</Button>}
        {pm.phone && <Button as="a" href={`tel:${String(pm.phone).replace(/\s+/g, "")}`} variant="secondary" className="w-full justify-start" data-testid="contact-phone"><Phone /> {pm.phone}</Button>}
        {!pm.email && !pm.phone && <p className="cp-body-sm">Datele de contact nu au fost publicate. Scrie-ne la <a href="mailto:suport@briskgrp.com" className="text-cp-accent hover:underline">suport@briskgrp.com</a>.</p>}
      </div>
    </Modal>
  );
}
